<template>
  <div class="pos-calculator">
    <div class="row">
      <!-- CASH INDICATOR -->
      <div class="col-12 mb-3 mx-auto">
        <div class="font-weight-bold">Cash Given</div>
        <input v-model="cashInput" disabled type="text" />
      </div>

      <div class="col-12 mb-3 mx-auto">
        <div class="font-weight-bold">Change</div>
        <input disabled v-model="change" type="text" />
      </div>

      <div class="col-12">
        <div class="row mx-0">
          <div class="w-100">
            <div class="btn-calc-container-wrapper">
              <div
                v-for="(cash, cashKey) in cashDenominations"
                :key="cashKey"
                v-on:click="onAdd(cash)"
                class="btn-calc-container"
              >
                <button class="btn-calc">{{ cash.denomination_value }}</button>
              </div>
              <div class="btn-calc-container">
                <button v-on:click="onClear()" class="btn-calc">C</button>
              </div>
              <!-- <div class="btn-calc-container">
                <button class="btn-calc">2</button>
              </div>
              <div class="btn-calc-container">
                <button class="btn-calc">3</button>
              </div>-->
            </div>

            <!-- <div class="d-flex">
              <div class="btn-calc-container">
                <button class="btn-calc">4</button>
              </div>
              <div class="btn-calc-container">
                <button class="btn-calc">5</button>
              </div>
              <div class="btn-calc-container">
                <button class="btn-calc">6</button>
              </div>
            </div>-->

            <!-- <div class="d-flex">
              <div class="btn-calc-container">
                <button class="btn-calc">7</button>
              </div>
              <div class="btn-calc-container">
                <button class="btn-calc">8</button>
              </div>
              <div class="btn-calc-container">
                <button class="btn-calc">9</button>
              </div>
            </div>-->

            <!-- <div class="d-flex">
              <div class="btn-calc-container">
                <button class="btn-calc">0</button>
              </div>
              <div class="btn-calc-container">
                <button class="btn-calc">.</button>
              </div>
              <div class="btn-calc-container">
                <button class="btn-calc">C</button>
              </div>
            </div>
            </div>-->

            <div class="w-50 pl-2">
              <!-- <div class="d-flex">
              <div class="btn-auto-denomination-container">
                <button class="btn-calc">5</button>
              </div>
              <div class="btn-auto-denomination-container">
                <button class="btn-calc">10</button>
              </div>
              </div>-->
              <!--
            <div class="d-flex">
              <div class="btn-auto-denomination-container">
                <button class="btn-calc">20</button>
              </div>
              <div class="btn-auto-denomination-container">
                <button class="btn-calc">50</button>
              </div>
              </div>-->

              <!-- <div class="d-flex">
              <div class="btn-auto-denomination-container">
                <button class="btn-calc">100</button>
              </div>
              <div class="btn-auto-denomination-container">
                <button class="btn-calc">200</button>
              </div>
              </div>-->

              <!-- <div class="d-flex">
              <div class="btn-auto-denomination-container">
                <button class="btn-calc">500</button>
              </div>
              <div class="btn-auto-denomination-container">
                <button class="btn-calc">1000</button>
              </div>
              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PosService from "@/services/PosService";
import { EventBus } from "@/main";
export default {
  data() {
    return {
      float_amount_given: 0.0,
      float_id: null,
      cashDenominations: [],
      // total: 0,
      cashRow: [],
      currency: "Rs.",
      change: 0
    };
  },
  mounted() {
    this.getCashInput();
    this.getCashDenominations();
    this.setCashInputChange();
    EventBus.$on("calculate_change_amount", (data) => {
     this.setCashInputChange();
    });
  },
  computed: {
     MeritCardAmount() {
      let amount = 0;
      let gc_details = this.$store.getters.GET_MERIT_GIFT_CARD_DETAILS;
      if(gc_details) {
        amount = +parseFloat(gc_details['amount']).toFixed(2)
      }
      return amount
    },
    ticketValue() {
      return (
        this.$store.getters.TOTAL_AMOUNT +
        this.$store.getters.selectedFnBItemsTotalPrice +
        this.$store.getters.TotalAdditionalTaxes -
        this.$store.getters.getOfferPrice -
        parseFloat(this.MeritCardAmount) -
        this.$store.getters.paid_amount -
        this.$store.getters.getloyaltyAmount +
        this.$store.getters.selectedAddonsTotalPrice
      );
    },
    SwapticketValue() {
      return (
        this.$store.getters.TOTAL_AMOUNT +
        this.$store.getters.selectedFnBItemsTotalPrice +
        this.$store.getters.TotalAdditionalTaxes -
        this.$store.getters.getOfferPrice -
        parseFloat(this.MeritCardAmount) -
        this.$store.getters.paid_amount -
        this.$store.getters.getloyaltyAmount +
        this.$store.getters.selectedAddonsTotalPrice -
        this.$store.getters.getSwapTotalAmount
      );
    },
    CashCardAmount() {
      return this.$store.getters.isCashCardDetail.hasOwnProperty("cardAmount")
        ? this.$store.getters.isCashCardDetail.cardAmount
        : 0;
    },

    // cashInput() {
    //   return this.$store.getters.CASH_INPUT;
    // },
    cashInput: {
      get: function() {
        return this.$store.getters.CASH_INPUT;
      },
      set: function(newValue) {
        if (!newValue) {
          this.onClear();
        }
        newValue = newValue ? newValue : 0.0;
        this.$store.dispatch("SET_CASH_INPUT", newValue);
        this.setCashInputChange();
      }
    }
  },
  watch: {
    // cashInput() {
    //   this.setCashInputChange();
    // }
  },
  methods: {
    getCashInput: function() {
      PosService.getCashInput()
        .then(result => {
          const { data } = result;
          if (data.status) {
            this.float_amount_given = data.Records[0].float_amount_given;
            this.float_id = data.Records[0].float_id;
          } else {
            // this.$toasted.show(data.message);
          }
        })
        .catch(err => {
          // this.$toasted.show(err);
        });
    },
    getCashDenominations: function() {
      PosService.getCashDenominations()
        .then(result => {
          const { data } = result;
          if (data.status) {
            this.cashDenominations = data.Records;
            this.cashDenominations.map(x => {
              x["count"] = 0;
              x["value"] = parseFloat(x.denomination_value);
              return x;
            });
          } else {
            // this.$toasted.show(data.message);
          }
        })
        .catch(err => {
          // this.$toasted.show(err);
        });
    },
    onAdd: function(data) {
      let index = this.cashRow.findIndex(
        x => x.denomination_value == data.denomination_value
      );
      if (index > -1) {
        data.count++;
        this.cashRow[index].value =
          parseFloat(data.denomination_value) * data.count;
      } else {
        data.count++;
        this.cashRow.push(data);
      }
      // this.$store.dispatch("SET_CASH_INPUT", 0);
      let tempVal = 0;
      this.cashRow.map(x => {
        tempVal += x.value;
        console.log("tempVal :", tempVal);
      });
      tempVal = parseFloat(tempVal).toFixed(2);
      this.$store.dispatch("SET_CASH_INPUT", tempVal);

      this.setCashInputChange();
    },
    setCashInputChange: function() {
      if (
        this.$store.getters.CASH_INPUT > this.ticketValue &&
        !this.$store.getters.isSwap &&
        !this.$store.getters.isCashCardTopUp
      ) {
        this.change = this.$store.getters.CASH_INPUT - this.ticketValue;
        this.change = this.change.toFixed(2);
      } else if (
        this.$store.getters.CASH_INPUT >
          this.$store.getters.getcashInputForCashCard &&
        this.$store.getters.isCashCardTopUp
      ) {
        this.change =
          this.$store.getters.CASH_INPUT -
          this.$store.getters.getcashInputForCashCard;
        this.change = this.change.toFixed(2);
      } else if (
        this.$store.getters.CASH_INPUT > this.SwapticketValue &&
        this.$store.getters.isSwap
      ) {
        this.change = this.$store.getters.CASH_INPUT - this.SwapticketValue;
        this.change = this.change.toFixed(2);
      }
    },
    onClear: function() {
      this.$store.dispatch("SET_CASH_INPUT", 0);
      // this.$store.getters.CASH_INPUT = 0;
      this.change = 0;

      this.cashRow = this.cashRow.map((x, key) => {
        x.count = 0;
        x.value = parseFloat(x.denomination_value);
        return x;
      });
      this.cashRow = [];
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Partials/posCalculator.vue